"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

/**
 * Resets scroll to the top on every route change.
 *
 * <body> is the scroll container (html is overflow: hidden), so Next's own
 * scroll reset, which targets the window, never moves it. Keyed on pathname
 * only so query-string updates on `/apply-online` don't jump the page.
 * `behavior: "instant"` overrides the smooth scrolling set on body.
 */
export const ScrollToTop = () => {
	const pathname = usePathname();

	useEffect(() => {
		// Navigations that carry a hash should land on that element, not the top.
		const id = decodeURIComponent(window.location.hash.slice(1));
		const target = id ? document.getElementById(id) : null;

		if (target) target.scrollIntoView({ behavior: "instant" });
		else document.body.scrollTo({ top: 0, left: 0, behavior: "instant" });
	}, [pathname]);

	return null;
};
